import { root, id } from './clip';

export const clip = {
  ...root,
  id: {
    ...id,
  },
};
